import { AppBar, Box, Card, CardContent, Grid, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import WithdrawalRequest from "./WithdrawalRequest";
import WithdrawalReport from "./WithdrawalReport";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Copyright from "../../internals/components/Copyright";
import { UserType } from "../../enums/userType";

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
			{value === index && <Box sx={{ padding: 0 }}>{children}</Box>}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		"aria-controls": `full-width-tabpanel-${index}`,
	};
}

const CustomerMainWithdrawal = ({ token, id, isAuthenticated, setIsAuthenticated }) => {
	const theme = useTheme();
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
			{/* cards */}
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Customer Withdrawals
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }}>
					<AppBar position="static">
						<Tabs
							value={value}
							onChange={handleChange}
							indicatorColor="blue"
							textColor="white"
							variant="fullWidth"
							aria-label="full width tabs example"
						>
							<Tab label="Requested Withdrawals" {...a11yProps(0)} />
							<Tab label="Processed Withdrawals" {...a11yProps(1)} />
						</Tabs>
					</AppBar>
					<TabPanel value={value} index={0} dir={theme.direction}>
						<WithdrawalRequest token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
					</TabPanel>
					<TabPanel value={value} index={1} dir={theme.direction}>
						<WithdrawalReport
							token={token}
							id={id}
							isAuthenticated={isAuthenticated}
							setIsAuthenticated={setIsAuthenticated}
							userType={UserType.CUSTOMER}
						/>
					</TabPanel>
				</Grid>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
};

export default CustomerMainWithdrawal;
